import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
  IconButton,
  Chip,
} from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import dayjs from 'dayjs'
import './remark-modal.scss'

const RemarkModal = ({ open, onClose, record }) => {
  if (!record) return null

  const getStatusColor = (status) => {
    switch (status) {
      case 'Paid':
        return 'success'
      case 'Pending':
        return 'warning'
      case 'Unpaid':
        return 'error'
      case 'To Be Raised':
        return 'default'
      case 'Draft':
        return 'default'
      default:
        return 'default'
    }
  }

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        onClose();
      }}
      maxWidth="sm"
      fullWidth
      className="remark-modal"
    >
      <DialogTitle>
        <div className="dialog-header">
          <span>Remarks</span>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <div className="remark-field">
              <Typography variant="subtitle2" className="field-label">
                Status
              </Typography>
              <Chip
                label={record.status}
                color={getStatusColor(record.status)}
                size="small"
              />
            </div>
          </Grid>

          {record.updatedAt && (
            <Grid item xs={12}>
              <div className="remark-field">
                <Typography variant="subtitle2" className="field-label">
                  Status Updated On
                </Typography>
                <Typography variant="body1" className="field-value">
                  {dayjs(record.updatedAt).format('DD/MM/YYYY, hh:mm A')}
                </Typography>
              </div>
            </Grid>
          )}

          {record.invoice && (
            <Grid item xs={12}>
              <div className="remark-field">
                <Typography variant="subtitle2" className="field-label">
                  Invoice Number
                </Typography>
                <Typography variant="body1" className="field-value">
                  {record.invoice}
                </Typography>
              </div>
            </Grid>
          )}
          
          {record.date && (
            <Grid item xs={12}>
              <div className="remark-field">
                <Typography variant="subtitle2" className="field-label">
                  Invoice Date
                </Typography>
                <Typography variant="body1" className="field-value">
                  {dayjs(record.date).format('DD/MM/YYYY')}
                </Typography>
              </div>
            </Grid>
          )}

          {record.dueDate && (
            <Grid item xs={12}>
              <div className="remark-field">
                <Typography variant="subtitle2" className="field-label">
                  Due Date
                </Typography>
                <Typography variant="body1" className="field-value">
                  {dayjs(record.dueDate).format('DD/MM/YYYY')}
                </Typography>
              </div>
            </Grid>
          )}

          <Grid item xs={12}>
            <div className="remark-field">
              <Typography variant="subtitle2" className="field-label">
                Remarks
              </Typography>
              <Typography variant="body1" className="field-value">
                {record.remark || 'No remarks available'}
              </Typography>
            </div>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RemarkModal
